import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { LoadingTask } from 'src/app/tools/ui/loading-task';
import { environment } from 'src/environments/environment';
const { version: appVersion } = require('../../../../package.json');

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavMenuComponent implements OnInit {
    ENavigationRoute = ENavigationRoute;
    @ViewChild('toggleButton', { read: ElementRef }) toggler!: ElementRef;
    @Output() stateChanged = new EventEmitter<string>();
    isExpanded = false;
    Opacity = 0;
    AppName = environment.appName;
    AppVersion!: string;

    get EurofinsIconPath() {
        return this.CoreData.IsMobile ? 'favicon.ico' : 'assets/eurofins-logo-white.png';
    }

    get DemetraIconPath() {
        return 'assets/Demetra_logo.png';
    }

    constructor(
        private router: Router,
        public loadingTask: LoadingTask,
        public CoreData: CoreData) {

    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.isMenuTogglerDisplayed();
    }

    ngOnInit() {
        this.AppVersion = appVersion;
        this.loadingTask.LoadingEmitter.subscribe(x => {
            if (x) {
                this.Opacity = 100;
            } else {
                this.Opacity = 0;
            }
        });
    }

    collapse() {
        this.isExpanded = false;
    }

    toggle() {
        this.isExpanded = !this.isExpanded;
        if (this.isExpanded) {
            this.stateChanged.emit('160px');
        } else {
            this.stateChanged.emit('80px');
        }
    }

    isMenuTogglerDisplayed() {
        return this.toggler && window.getComputedStyle(this.toggler.nativeElement).display !== 'none';
    }

    navigateToHome() {
        this.router.navigate([ENavigationRoute.Home]);
    }

}
